import { render, staticRenderFns } from "./admin-knobs.vue?vue&type=template&id=392d56f4&scoped=true&"
import script from "./admin-knobs.vue?vue&type=script&lang=js&"
export * from "./admin-knobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d56f4",
  null
  
)

export default component.exports